import { IonContent } from '@ionic/react';
import React from 'react';

import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import { useCharacterFolder } from '../../hooks';

import {
  MainImageStyles,
  OverlayStyles,
  PageStyles,
  PageTitleStyles,
  SubtitleStyles,
} from './AboutPersonalityScreen.styles';

export const AboutPersonalityScreen: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'AboutPersonalityScreen',
      });
    }
  }, []);

  const { wizard } = useOnboarding();
  const { getAsset } = useCharacterFolder();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <PageStyles>
      <IonContent scrollY={false}>
        <OverlayStyles />
        <MainImageStyles>
          <img
            src={getAsset('about_personality/splash.jpg')}
            alt="AI Character"
          />
        </MainImageStyles>
        <div className="content-wrapper">
          <PageTitleStyles
            className="page-title"
            component="h1"
            variant="title-medium"
            align="center"
          >
            Nice! His Personality Shines Bright!
            <SubtitleStyles variant={'body-medium'}>
              You've crafted a truly unique character
              <br />
              —well done!
            </SubtitleStyles>
          </PageTitleStyles>
          <OnboardingFooter
            buttonSize={'large'}
            buttonRadius="md"
            onContinue={handleNextStep}
          />
        </div>
      </IonContent>
    </PageStyles>
  );
};
